import styles from './LoginPageHeaderComponent.module.scss';
import metadata from './LoginPageHeaderComponent.metadata.json5';
import messages from './LoginPageHeaderComponent.messages';
import React, { useCallback, useContext } from 'react';
import { MetadataForm } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import { CustomIconUtil } from 'gw-portals-util-js';

function LoginPageHeaderComponent(props) {
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = (breakpoint === 'phoneWide' || breakpoint === 'phone' || breakpoint === 'tablet');

    const overrideProps = {
        amiglogo: {
            href: 'https://policyholders.amig.com'
        },
        amigimage: {
            src: CustomIconUtil.getLogoSrc('AMIG-desktopHeaderLogo.png'),
            disabled: true,
            alt: "amig-logo"
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
        },
    };

    return (
        <MetadataForm
            uiProps={metadata.componentContent}
            classNameMap={styles}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
    );
}

LoginPageHeaderComponent.propTypes = {

};

export default LoginPageHeaderComponent;